import { createReducer } from "redux-starter-kit";
import { showCopyModalAction } from "../actions/copyModal";

const INIT_STATE = {
  showCopyModal: false
};

const copyMoal = createReducer(INIT_STATE, {
  [showCopyModalAction]: (state, action) => {
    state.showCopyModal = action.payload.showCopyModal;
  }
});

export default copyMoal;
